import { Component, Optional } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LearnMore } from '../../../models/learn-more.model';

@Component({
  selector: 'app-learn-more',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './learn-more.component.html',
  styleUrl: './learn-more.component.scss',
})
export class LearnMoreComponent {
  learnMoreScreens: LearnMore[];
  currentStep: number = 0;
  currentScreen: LearnMore;

  constructor(
    @Optional() private matDialogRef: MatDialogRef<LearnMoreComponent> | null
  ) {
    if (matDialogRef) matDialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.matDialogRef.addPanelClass('learn-more-dialog-v18');
    this.setLearnMoreScreenConfig();
  }

  setLearnMoreScreenConfig = () => {
    this.learnMoreScreens = [
      {
        heading: 'Step 1. Entity Representative Aadhaar Verification',
        subHeading: 'Enter Your Aadhar Number',
        imageUrl: 'images/lm-entity-locker.png',
      },
      {
        heading: 'Step 1. Entity Representative Aadhaar Verification',
        subHeading: 'Verify Your Aadhar by Authenticate by OTP',
        imageUrl: 'images/lm-verify-number.png',
      },
      {
        heading: 'Step 2. PIN Creation',
        subHeading: 'Now Create Your Secure PIN',
        imageUrl: 'images/lm-pin-reset.png',
      },
      {
        heading: 'Step 3. Choose Suitable Option to Register.',
        subHeading: 'Option 1. MSME-UDYAM',
        imageUrl: 'images/lm-choose-options.png',
      },
      {
        heading: 'Step 4. Upload Documents',
        subHeading: 'Upload Your Documents for Verification',
        imageUrl: 'images/lm-upload-documents.png',
      },
      {
        heading:
          'Step 5. eSign Registration Agreement by Entity Representation',
        subHeading: 'Get Your eSign Registration Agreement',
        imageUrl: 'images/lm-agreement.png',
      },
    ];

    this.currentScreen = this.learnMoreScreens[this.currentStep];
  };

  onNext = () => {
    this.currentStep += 1;
    this.currentScreen = this.learnMoreScreens[this.currentStep];
  };

  onPrev = () => {
    this.currentStep -= 1;
    this.currentScreen = this.learnMoreScreens[this.currentStep];
  };
}
